<template>
  <layout-public>
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-col md="4" offset-md="4">
          <v-content>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Verify Email Address</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  :error-messages="emailErrorMessage"
                  v-model="email"
                  prepend-icon="fa-envelope"
                  label="Email Address"
                  type="text"
                  required
                  filled
                  @input="clearError"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  to="/login"
                  color="grey300"
                  class="ml-4 mb-4 cancel-button"
                  >Cancel</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn v-if="loading" color="primary mb-4 mr-3" loading></v-btn>
                <v-btn
                  @click="reset"
                  color="dark-blue"
                  class="mb-4 mr-3 add-course-button"
                  v-else
                  >Reset Password</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-content>
        </v-col>
      </v-row>
    </v-container>
  </layout-public>
</template>
<script>
import LayoutPublic from '@/layouts/Public';
import authAPI from '@/api/auth.js';

export default {
  name: 'ForgotPassword',
  components: {
    LayoutPublic,
  },
  data: () => ({
    email: '',
    reseturl: 'password-reset',
    valid: true,
    messages: {},
    disabled: true,
    emailErrorMessage: '',
    loading: false
  }),
  methods: {
    reset() {
      // Trim spaces and special characters
      this.email = this.email.trim();
      const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
      if (!this.email) {
        this.emailErrorMessage = "The ‘Email’ field is required";
      } else if (!emailPattern.test(this.email)) {
        this.emailErrorMessage = "The ‘Email’ field should contain valid e-mail format";
      } else {
        this.loading = true;
        this.emailErrorMessage = "";
      authAPI
        .forgotPassword(this.email, this.reseturl)
        .then(() => {
          this.$snotify.success(
            'A password reset email has been sent to the email entered. Please note that it may take up to 5 minutes to arrive'
          );
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          this.$router.push('/login');
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.messages = [];
          let errors = err.response.data.errors;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.$snotify.error(errMsg);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
      }
    },
    clearError() {
      this.emailErrorMessage = "";
    }
  },
};
</script>
